import React from 'react';
import './tn.css';
import './tn.png';

export default class YoutubeThumbnail extends React.Component {
  componentDidMount() {
    this.props.onMount();
  }
  render() {
    const { id, onClick } = this.props;
    return (
      <div className="thumb">
        <div onClick={onClick} className={`sprite-tn-${id} thumbnail `}/>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/YoutubeThumbnail.js
 **/